import React, { useEffect, useState } from 'react';
import NftCard from '../Card/NftCard';
import { collection, getDocs, query, where } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { skeleTonJson } from '../common/jsonDumb';

export default function OnSellsTab(props) {
  const [nftDataArr, setnftDataArr] = useState([]);
  const [loadingNfts, setloadingNfts] = useState(true);

  const [avgPrice, setavgPrice] = useState(0);

  useEffect(() => {
    if (props.collectorId) {
      getSellerNfts();
    }
  }, [props.collectorId]);

  const getSellerNfts = async () => {
    setloadingNfts(true);

    let nftRef1 = query(
      collection(firebaseFireStore, 'musicartNfts'),
      where('adminState', '==', 'ACCEPT'),
      where('usersId', 'array-contains', props.collectorId),
    );

    let nftData1 = await getDocs(nftRef1);

    let dataArr = [];

    //multiple
    // nftData1.forEach((doc) => {
    //   let cObj = doc.data();
    //   if (cObj.isMultiple) {
    //     Object.values(cObj.multipleNftDetails).map((ele, index) => {
    //       if (
    //         ele.activeInMarketPlace &&
    //         ele.adminState === "ACCEPT" &&
    //         ele.userId === props.collectorId
    //       ) {
    //         dataArr.push({ ...cObj, ...ele });
    //       }
    //     });
    //   }
    // });

    nftData1.forEach((docer) => {
      let cObj = docer.data();

      if (cObj.isMultiple && Number(cObj.nftQuantity) > 1) {
        let startingPrice = 0;
        Object.values(cObj.multipleNftDetails)
          .filter((x) => x.activeInMarketPlace)
          .map((ele, index) => {
            if (ele.adminState === 'ACCEPT' && ele.activeInMarketPlace) {
              if (
                ele.nftSaleType &&
                ele.nftSaleType !== 'Auctioning' &&
                ele.price &&
                (!startingPrice ||
                  (startingPrice && Number(ele.price) < startingPrice))
              ) {
                startingPrice = Number(ele.price);
              } else if (
                ele.nftSaleType &&
                ele.nftSaleType === 'Auctioning' &&
                ele.auctionEndTime &&
                ele.minBiddingPrice &&
                (!startingPrice ||
                  (startingPrice &&
                    Number(ele.minBiddingPrice) < startingPrice))
              ) {
                startingPrice = Number(ele.minBiddingPrice);
              }
            }
          });
        cObj.preview && console.log('cObj **', cObj);
        if (startingPrice || cObj.preview) {
          dataArr.push({ ...cObj, startingPrice: startingPrice });
        }
      } else {
        if (
          (cObj.nftSaleType &&
            cObj.nftSaleType === 'Auctioning' &&
            cObj.auctionEndTime &&
            cObj.minBiddingPrice) ||
          (cObj.nftSaleType !== 'Auctioning' && cObj.price) ||
          cObj.preview
        ) {
          dataArr.push(cObj);
        }
      }
    });

    dataArr.sort((a, b) => Number(b.likes) - Number(a.likes));

    let lAvgPrice = 0;

    dataArr.map((a, b) => {
      lAvgPrice = lAvgPrice + a.price;
    });

    lAvgPrice = lAvgPrice / dataArr.length;

    setavgPrice(Math.round(lAvgPrice));

    setnftDataArr([...dataArr]);
    setloadingNfts(false);
  };

  return (
    <div className="seller__tab__pane" role="tabpanel">
      <div className="seller__tab__content">
        <div className="row row--grid">
          {loadingNfts
            ? skeleTonJson.slice(0, 6).map((ele, index) => (
                <div
                  style={{ display: 'block' }}
                  className="turning-screens-artist "
                  key={'nft-' + index}
                >
                  <NftCard ele={ele} index={index} />
                </div>
              ))
            : nftDataArr.map((ele, index) => {
                if (
                  (ele.nftSaleType &&
                    ele.nftSaleType === 'Auctioning' &&
                    ele.auctionEndTime) ||
                  ele.nftSaleType !== 'Auctioning'
                ) {
                  return (
                    <div
                      style={{ display: 'block' }}
                      className="turning-screens-artist "
                      key={'nft-' + index}
                    >
                      <NftCard
                        nftDataArr={nftDataArr}
                        ele={ele}
                        index={index}
                        nftDataArr={nftDataArr}
                        setnftDataArr={setnftDataArr}
                        category={'collector_tab_on_sale' + index}
                      />
                    </div>
                  );
                }
              })}
          {!loadingNfts && nftDataArr.length === 0 && (
            <div className="text-center w-full text-blueGray-500">
              <p className="text-center mt-10">0 NFTs found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
